import { shape, func } from 'prop-types';

export default shape({
    openMobileMenu: func,
    closeMobileMenu: func,
});
